class CommCodeModel {

    constructor(commCode) {

        const {
            commCd,
            commCdName,
        } = commCode;

        this.label = commCdName;
        // TODO
        this.value = commCd.trim();

    }

}

export default CommCodeModel;